"use strict";

require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.reflect.construct.js");
require("core-js/modules/es.array.iterator.js");
require("core-js/modules/es.string.iterator.js");
require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
require("core-js/modules/es.object.get-own-property-descriptor.js");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _button = require("@citrus/button");
var _flyout = require("@citrus/flyout");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var PctyQuestionBuilderEditPageManagerButton = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(PctyQuestionBuilderEditPageManagerButton, _Component);
  var _super = _createSuper(PctyQuestionBuilderEditPageManagerButton);
  function PctyQuestionBuilderEditPageManagerButton(props) {
    var _this;
    (0, _classCallCheck2.default)(this, PctyQuestionBuilderEditPageManagerButton);
    _this = _super.call(this, props);
    _this.state = {
      flyoutOpen: false
    };
    _this.toggleFlyout = _this.toggleFlyout.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }
  (0, _createClass2.default)(PctyQuestionBuilderEditPageManagerButton, [{
    key: "toggleFlyout",
    value: function toggleFlyout() {
      var flyoutOpen = !this.state.flyoutOpen || false;
      this.setState({
        flyoutOpen: flyoutOpen
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var id = this.props.id;
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, this.props.isActive ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_button.SecondaryButton, {
        "data-pcty-flyout-id": "".concat(id, "-dropdown-flyout-menu"),
        dropdown: true,
        disabled: this.props.disabled,
        onClick: this.toggleFlyout
      }, "Page ".concat(this.props.pageNumber)), /*#__PURE__*/_react.default.createElement(_flyout.Flyout, {
        className: "pcty-padding-none",
        hasPointer: false,
        id: "".concat(id, "-dropdown-flyout-menu"),
        open: this.state.flyoutOpen,
        location: "bottom-start",
        onClose: this.toggleFlyout
      }, /*#__PURE__*/_react.default.createElement(_flyout.Flyout.MenuItem, {
        disabled: this.props.disabled,
        onClick: function onClick() {
          return _this2.props.onClickDuplicatePage(id);
        }
      }, "Duplicate"), !this.props.disabled && this.props.allowDelete && /*#__PURE__*/_react.default.createElement(_flyout.Flyout.MenuItem, {
        onClick: function onClick() {
          return _this2.props.onClickDeletePage(id);
        }
      }, "Delete"))) : /*#__PURE__*/_react.default.createElement(_button.BorderlessButton, {
        className: "pcty-padding-left pcty-padding-right",
        disabled: this.props.disabled,
        onClick: function onClick() {
          return _this2.props.onClickSelectPage(id);
        }
      }, "Page ".concat(this.props.pageNumber)));
    }
  }]);
  return PctyQuestionBuilderEditPageManagerButton;
}(_react.Component);
PctyQuestionBuilderEditPageManagerButton.propTypes = {
  id: _propTypes.default.string.isRequired,
  isActive: _propTypes.default.bool.isRequired,
  allowDelete: _propTypes.default.bool.isRequired,
  disabled: _propTypes.default.bool.isRequired,
  pageNumber: _propTypes.default.number.isRequired,
  onClickDuplicatePage: _propTypes.default.func.isRequired,
  onClickDeletePage: _propTypes.default.func.isRequired,
  onClickSelectPage: _propTypes.default.func.isRequired
};
var _default = exports.default = PctyQuestionBuilderEditPageManagerButton;